import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCrudComponent } from '@app/admin/base-crud.component';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { CreateEditPersonOperatorComponent } from '@app/core/windows'; 


@Component({
  selector: 'persons-operators-crud',
  templateUrl: './persons-operators-crud.component.html',
  providers: [ DatasourceService ]
})
export class PersonsOperatorsCrudComponent extends BaseCrudComponent implements OnInit {

  //Window
  @ViewChild(CreateEditPersonOperatorComponent, {static: false}) window !: CreateEditPersonOperatorComponent;

  protected menu: string = 'Conceptos';

  protected menuIcon: string = 'gears';
  
  protected label: string = 'Personal operador';

  protected name: string = 'Personal operador';

  protected table: string = 'persons_operators';
  
  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService) {
    
    super(authService, service, alertService);
    console.log(this.constructor.name);
    this.breadcrumbItems = this.getBreadcumItems();

  }  

  //Overrides
  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.sort = [      
      {field: 'name', dir: 'asc'}
    ];

    return s;

  }

  ngOnInit() { 
    
    super.ngOnInit();    
  
  }

}